import React, { useEffect, useState } from 'react';
import {
    DropdownMenuStateless,
    DropdownItemGroup,
    DropdownItem
} from '@atlaskit/dropdown-menu';
import './filter-selector.less';
import { FilterValue } from '../types';

interface FilterProps {
    filterTitle: string;
    filterValues: FilterValue[];
    setQueryValues: any;
    allowFilterAll?: boolean;
    queryByString?: boolean;
    shouldReset?: boolean;
    setShouldReset?: any;
    titleReset?: boolean;
    setTitleReset?: any;
}

const FilterSelector = ({
    filterTitle,
    filterValues,
    setQueryValues,
    allowFilterAll = true,
    queryByString = false,
    shouldReset,
    setShouldReset,
    titleReset,
    setTitleReset
}: FilterProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState(filterTitle);

    useEffect(() => {
        if (shouldReset) {
            setSelected(filterTitle);
            setShouldReset(false);
        }
    }, [shouldReset, filterTitle, setShouldReset]);

    useEffect(() => {
        if (titleReset) {
            setSelected(filterTitle);
            setTitleReset(false);
        }
    }, [filterTitle, setTitleReset, titleReset]);

    return (
        <div
            className="dropdown-container"
            data-testid={`filter-selector-${filterTitle}`}
        >
            <DropdownMenuStateless
                trigger={selected}
                triggerType="button"
                isOpen={isOpen}
                onOpenChange={() => setIsOpen(!isOpen)}
            >
                <DropdownItemGroup title={filterTitle}>
                    {allowFilterAll && (
                        <DropdownItem
                            key={`All-${filterTitle}s`}
                            onClick={() => {
                                setSelected(`All ${filterTitle}s`);
                                setQueryValues(
                                    filterValues.map(
                                        ({ queryString }) => queryString
                                    )
                                );
                            }}
                        >
                            {`All ${filterTitle}s`}
                        </DropdownItem>
                    )}
                    {filterValues.map(({ name, queryString }) => (
                        <DropdownItem
                            key={name}
                            onClick={() => {
                                setSelected(name);
                                setQueryValues(
                                    queryByString ? queryString : [queryString]
                                );
                            }}
                        >
                            {name}
                        </DropdownItem>
                    ))}
                </DropdownItemGroup>
            </DropdownMenuStateless>
        </div>
    );
};

export default FilterSelector;
